'use client';

import { FC, HTMLAttributes } from 'react';

import { useTabsContext } from '../dynamo-tabs/tabs.context';

export interface TabProps extends HTMLAttributes<HTMLDivElement> {}

export const TabContent: FC<TabProps> = ({ id, ...props }) =>
  id === useTabsContext()?.activeTabId ? <div {...props} /> : null;
